var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"burger",class:{'burger--open': _vm.isOpen },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger__wrapper"},[_c('div',{staticClass:"burger__line"}),_vm._v(" "),_c('div',{staticClass:"burger__line"}),_vm._v(" "),_c('div',{staticClass:"burger__line"})])
}]

export { render, staticRenderFns }